<template>
  <a v-if="user.isRep" href="#" @click.prevent="downloadAll">
    <slot name="icon"><i class="pi pi-download" /></slot>
    <slot></slot>
  </a>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user";
import { download, zip, type DownloadLink } from "@/utils/download";
import { extname, filename } from "@/utils/formats";

const props = withDefaults(
  defineProps<{
    images: any[];
    download?: string;
    zip?: boolean;
  }>(),
  {
    zip: false,
    download: "image",
  },
);

const user = useUserStore();

async function downloadAll() {
  let images = [];
  images = await getDownloadLinks();
  if (props.zip) {
    images = [await zip(images)];
  }
  await download(images);
}

async function getDownloadLinks(): Promise<DownloadLink[]> {
  return props.images.map((image, index) => {
    if (typeof image === "string") {
      return {
        filename: filename(image),
        url: image,
      };
    } else {
      return {
        filename: `${props.download}-${index}.${extname(image.original)}`,
        url: image.original,
      };
    }
  });
}
</script>

<style scoped></style>
